import '../Common.css';
import {CSSProperties, ReactNode} from 'react';

interface InteractiveElementProps {
  children: ReactNode,
  className?: string,
  style?: CSSProperties,
  circle?: boolean,
  disabled?: boolean,
  noBorder?: boolean,
  selected?: boolean,
}

const InteractiveElement = ({ children, style, circle, noBorder, className, disabled, selected }: InteractiveElementProps) => (
  <div
    className={`${circle ? 'interactive-element-circular' : ''}
      ${className || ''}
      ${noBorder || disabled ? '' : 'interactive-element-border'}
      ${!noBorder && disabled ? 'interactive-element-border-disabled' : ''}
      ${disabled ? 'interactive-element-disabled' : 'interactive-element'}
      ${selected ? 'selected-interactive-element' : ''}`}
    style={style}
  >
    {children}
  </div>
);

export default InteractiveElement;
